import { render } from "./Tabs.vue?vue&type=template&id=7a0fc4b2"
const script = {}
script.render = render

export default script